(function () {
  'use strict';

  /* @ngdoc object
   * @name wbCta
   * @description
   *
   */
  angular
    .module('wbCta', [
      'ui.router'
    ]);
}());
